import { store } from '../OpenPixStore.tsx';

/**
 * $openpix.push([
 *   'close',
 *  ])
 */
export const closeModal = () => {
  store.setState({
    isOpen: false,
    value: null,
    description: null,
    correlationID: null,
    success: false,
  });
};
